import { put, call, takeEvery } from "redux-saga/effects";
import athenaClient from "lib/axios/clients";
import buildRequestUrl from "lib/requests/requestUtils";
import _ from "lodash";
import { addRetailersList } from "./slices";
import addRetailersListAsyncAction from "./actions";

function* addRetailerListAsync(action) {
  const url = buildRequestUrl(action.payload, "retailers");

  const config = {
    method: "GET",
    url,
  };

  const response = yield call(athenaClient, config);

  put(addRetailersList(_.keyBy(response.data, "id")));
}

export default function* watchAddRetailerListAsync() {
  yield takeEvery(addRetailersListAsyncAction, addRetailerListAsync);
}
